export const EVENT_DEFINITIONS = Object.freeze([
  // Home page
  { type: 'link', path: '/', eventName: 'home_page_link_click' },
  { type: 'button', path: '/', eventName: 'home_page_button_click' },
  { type: 'submit', path: '/', eventName: 'home_page_form_submit' },

  // Activities
  { type: 'submit', path: '/activities', eventName: 'activities_submit' },

  // Announcements
  { type: 'submit', path: '/announcements', eventName: 'announcements_view' },
  { type: 'button', path: '/announcements/{id}/edit', eventName: 'announcement_edit_click' },
  { type: 'button', path: '/announcements/create', eventName: 'announcement_create_click' },

  // Basket
  { type: 'link', path: '/basket', eventName: 'basket_view' },
  { type: 'button', path: '/basket', eventName: 'basket_action' },
  { type: 'link', path: '/basket-edit', eventName: 'basket_edit_view' },
  { type: 'button', path: '/basket-edit', eventName: 'basket_edit_action' },

  // Booking builder
  { type: 'button', path: '/booking-builder', eventName: 'booking_builder_action' },

  // Bookings
  { type: 'link', path: '/bookings', eventName: 'bookings_list_view' },

  // Content
  { type: 'link', path: '/content', eventName: 'content_list_view' },
  { type: 'link', path: '/content/{id}', eventName: 'content_detail_view' },
  { type: 'button', path: '/content/create', eventName: 'content_create_click' },

  // CRM
  { type: 'button', path: '/crm/activity', eventName: 'crm_activity_click' },
  { type: 'button', path: '/crm/company/create', eventName: 'crm_company_create_click' },
  { type: 'button', path: '/crm/contact/{id}/edit/activity', eventName: 'crm_contact_edit_activity' },
  { type: 'link', path: '/crm/contact/create', eventName: 'crm_contact_create_view' },
  { type: 'link', path: '/crm/dashboard/crm-metrics', eventName: 'crm_metrics_view' },
  { type: 'button', path: '/crm/dashboard/sales-metrics', eventName: 'sales_metrics_click' },
  { type: 'submit', path: '/crm/directory', eventName: 'crm_directory_search' },

  // Filters
  { type: 'submit', path: '/filters', eventName: 'filters_apply' },

  // Finance
  { type: 'submit', path: '/finance/bank-transactions', eventName: 'bank_transactions_search' },

  // Hotel admin
  { type: 'link', path: '/hotel-admin', eventName: 'hotel_admin_view' },
  { type: 'link', path: '/hotel-admin/{id}/edit', eventName: 'hotel_admin_edit_view' },

  // Hotels collection
  { type: 'link', path: '/hotels-collection', eventName: 'hotels_collection_view' },
  { type: 'link', path: '/hotels-collection/{id}', eventName: 'hotel_collection_detail_view' },

  // Hotels
  { type: 'link', path: '/hotels/{id}', eventName: 'hotel_detail_view' },

  // Itinerary
  { type: 'link', path: '/itinerary/{id}/1', eventName: 'itinerary_view' },

  // Live rates
  { type: 'submit', path: '/live-rates', eventName: 'live_rates_query' },
  { type: 'link', path: '/live-rates/{id}/settings', eventName: 'live_rates_settings_view' },

  // Login error
  { type: 'link', path: '/login-error', eventName: 'login_error_view' },

  // Logout
  { type: 'submit', path: '/logout', eventName: 'user_logout' },

  // Offers
  { type: 'link', path: '/offers', eventName: 'offers_list_view' },
  { type: 'submit', path: '/offers/create/applications', eventName: 'offer_application_submit' },
  { type: 'link', path: '/offers/create/combinations', eventName: 'offer_combinations_view' },
  { type: 'link', path: '/offers/create/packages', eventName: 'offer_packages_view' },
  { type: 'link', path: '/offers/create/pre-requisites', eventName: 'offer_prerequisites_view' },
  { type: 'submit', path: '/offers/create/priority', eventName: 'offer_priority_submit' },

  // Products
  { type: 'button', path: '/products/import', eventName: 'product_import_click' },

  // Proposals
  { type: 'submit', path: '/proposals-v2', eventName: 'proposals_search_submit' },
  { type: 'link', path: '/proposals-v2/{id}/edit', eventName: 'proposal_edit_view' },

  // Pure AI
  { type: 'link', path: '/pure-ai', eventName: 'pure_ai_view' },

  // Rate breaks
  { type: 'submit', path: '/rate-breaks', eventName: 'rate_breaks_submit' },

  // Rates
  { type: 'button', path: '/rates/import', eventName: 'rates_import_click' },

  // Reviews
  { type: 'button', path: '/reviews/{id}', eventName: 'reviews_action' },

  // Search
  { type: 'submit', path: '/search/beta', eventName: 'search_query_submit' },

  // Settings
  { type: 'link', path: '/settings/company-details', eventName: 'company_settings_view' },

  // Statements
  { type: 'link', path: '/statement/all', eventName: 'statements_all_view' },
  { type: 'link', path: '/statement/{id}', eventName: 'statement_detail_view' },
  { type: 'link', path: '/statement/{id}/bookings/usd/bookings-statement', eventName: 'statement_bookings_view' },
  { type: 'link', path: '/statement/{id}/bookings/usd/all-transactions', eventName: 'statement_transactions_view' },
  { type: 'button', path: '/statement/{id}/deposits/eur', eventName: 'statement_deposit_click' },

  // Static rates
  { type: 'button', path: '/static-rates-availability/import', eventName: 'static_rates_import_click' },

  // Tasks
  { type: 'link', path: '/tasks', eventName: 'tasks_list_view' },
  { type: 'button', path: '/tasks/{id}/edit', eventName: 'task_edit_click' },

  // Terms
  { type: 'link', path: '/terms-and-conditions', eventName: 'terms_view' },

  // Travel agents
  { type: 'link', path: '/travel-agents', eventName: 'travel_agents_view' },
  { type: 'link', path: '/travel-agents/{id}/edit', eventName: 'travel_agent_edit_view' },

  // Travel companies
  { type: 'link', path: '/travel-companies', eventName: 'travel_companies_view' },
  { type: 'link', path: '/travel-companies/{id}/settings', eventName: 'travel_company_settings_view' },

  // Users
  { type: 'link', path: '/users', eventName: 'users_list_view' },
  { type: 'link', path: '/users/{id}/edit', eventName: 'user_edit_view' },
  { type: 'button', path: '/users/create', eventName: 'user_create_click' },

  // VCC
  { type: 'button', path: '/vcc/export', eventName: 'vcc_export_click' },

  // Voucher
  { type: 'button', path: '/voucher/{id}', eventName: 'voucher_view' },
]);
